// Reports errors to the server (spec §16.5), so they show up in the console
// instead of going unnoticed. At most 5 per page, each message once. Not sent:
// browser extensions' errors, cross-origin "Script error.", ResizeObserver
// warnings, and API errors (the server already knows about those).
import { ApiError } from './api.ts';

const MAX_PER_PAGE = 5;
const sent = new Set<string>();

function report(message: string, stack?: string): void {
  if (!message || sent.size >= MAX_PER_PAGE || sent.has(message)) return;
  if (message === 'Script error.' || /ResizeObserver loop/.test(message)) return;
  if (stack && /(chrome|moz|safari|safari-web)-extension:\/\//.test(stack)) return;
  sent.add(message);
  fetch('/api/errors', {
    method: 'POST',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message: message.slice(0, 1000), stack: stack?.slice(0, 4000), path: location.pathname }),
  }).catch(() => { /* nowhere to report that */ });
}

export function installErrorReporting(): void {
  addEventListener('error', (e) => {
    const err = e.error as unknown;
    report(err instanceof Error ? `${err.name}: ${err.message}` : e.message, err instanceof Error ? err.stack : undefined);
  });
  addEventListener('unhandledrejection', (e) => reportError(e.reason));
}

/** Reports an error the app caught (e.g. a page that failed to load), unless it came from the API. */
export function reportError(err: unknown): void {
  if (err instanceof ApiError) return;
  report(err instanceof Error ? `${err.name}: ${err.message}` : String(err), err instanceof Error ? err.stack : undefined);
}
